import React from "react";

const MySVG = () => {
  return (
    <svg width="80" height="60" viewBox="5 0 80 60">
      <path
        class="wave"
        fill="none"
        stroke="#81c3d7"
        stroke-width="2"
        stroke-linecap="round"
        d="M 0 37.5 c 7.684299348848887 0 7.172012725592294 -15 15 -15 s 7.172012725592294 15 15 15 s 7.172012725592294 -15 15 -15 s 7.172012725592294 15 15 15 s 7.172012725592294 -15 15 -15 s 7.172012725592294 15 15 15 s 7.172012725592294 -15 15 -15 s 7.172012725592294 15 15 15 s 7.172012725592294 -15 15 -15 s 7.172012725592294 15 15 15 s 7.172012725592294 -15 15 -15 s 7.172012725592294 15 15 15 s 7.172012725592294 -15 15 -15 s 7.172012725592294 15 15 15 s 7.172012725592294 -15 15 -15"
      />
    </svg>
  );
};

export default MySVG;
